module.exports = __webpack_public_path__ + "static/media/invest1.2168fab7.svg";